import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadedFile } from '@app/services/file.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-file-preview-card',
  templateUrl: './file-preview-card.component.html',
  styleUrls: ['./file-preview-card.component.scss'],
  standalone: false
})
export class FilePreviewCardComponent {
  @Input() file!: UploadedFile;
  @Input() fileLoaded: boolean = false;
  @Input() folderName: string = '';
  @Output() fileLoadedChange = new EventEmitter<boolean>();
  @Output() openFileRequest = new EventEmitter<UploadedFile>();

  getFileIcon(type: string): string {
    if (type.startsWith('image/')) return 'image';
    if (type.includes('pdf')) return 'picture_as_pdf';
    if (type.includes('word') || type.includes('document')) return 'description';
    if (type.includes('excel') || type.includes('spreadsheet')) return 'table_chart';
    if (type.includes('text')) return 'text_snippet';
    if (type.includes('typescript') || type.includes('javascript')) return 'code';
    if (type.includes('css')) return 'css';
    return 'insert_drive_file';
  }

  isImage(type: string): boolean {
    return type.startsWith('image/');
  }

  isPDF(type: string): boolean {
    return type.includes('pdf');
  }

  openFile(): void {
    window.open(environment.apiUrl + 'files/' + this.file.id, '_blank');
  }
}
